/**
 * Main page implementation.
 *
 * @author Stanislav Kalashnik <sk@infomir.eu>
 * @license GNU GENERAL PUBLIC LICENSE Version 3
 */

'use strict';

var id            = 'pageInfo',
    Page          = require('stb-component-page'),
    app           = require('mag-app'),
    page          = new Page({$node: document.getElementById(id)}),
    PanelSet      = require('mag-component-panel-set'),
    PanelExtended = require('mag-component-panel'),
    LayoutList    = require('mag-component-layout-list'),
    Button        = require('stb-component-button'),
    Flicker       = require('spa-component-flicker'),
    keys          = require('stb-keys'),
    tools         = require('../modules/tools'),
    statuses      = [
        gettext('Paused'),
        gettext('Waiting'),
        gettext('Running'),
        gettext('Completed'),
        gettext('Error'),
        gettext('Error')
    ];


page.clock = new Flicker({
    className: 'clock',
    interval: 1000,
    render: function ( $item ) {
        var time  = new Date(),
            hours = time.getHours(),
            mins  = time.getMinutes();

        $item.innerText = (hours > 9 ? hours : '0' + hours) + ':' + (mins > 9 ? mins : '0' + mins);
    }
});
page.add(page.clock);
page.clock.start();

// details panel
page.panelDetails = new PanelExtended({
    title: gettext('About download'),
    main: true,
    visible: true,
    className: 'panelDetails',
    children: []
});

page.panelDetails.reset = function () {
    page.panelDetails.list.init({
        focusIndex: 0,
        data: [
            {
                items: [
                    {className: 'item name theme-subhead-color', value: gettext('URL:')},
                    {className: 'item text', value: page.initData.url}
                ]
            },
            {
                items: [
                    {className: 'item name theme-subhead-color', value: gettext('File name:')},
                    {className: 'item text', value: decodeURIComponent(page.initData.name)}
                ]
            },
            {
                items: [
                    {className: 'item name theme-subhead-color', value: gettext('Size:')},
                    {className: 'item text', value: tools.convert(page.initData.size)}
                ]
            },
            {
                items: [
                    {className: 'item name theme-subhead-color', value: gettext('Device:')},
                    {
                        className: 'item text',
                        value: page.initData.storage ? page.initData.storage.label : gettext('Not connected')
                    }
                ]
            },
            {
                items: [
                    {className: 'item name theme-subhead-color', value: gettext('Status:')},
                    {className: 'item text', value: statuses[page.initData.state]}
                ]
            }
        ]
    });
    page.panelDetails.$node.classList.add('disabled');
    page.panelDetails.focus();
    if ( page.panelDetails.list.$focusItem ) {
        page.panelDetails.list.$focusItem.classList.remove('focus');
    }
    page.panelDetails.button.focus();
};

page.panelDetails.add(page.panelDetails.list = new LayoutList({
    focusIndex: 0,
    size: 5,
    events: {
        overflow: function () {
            page.panelDetails.list.$focusItem.classList.remove('focus');
            page.panelDetails.button.focus();
        },
        'click:item': function ( data ) {
            if ( page.panelDetails.list.$focusItem ) {
                app.route(app.pages.more, data);
            }
        },
        keydown: function ( event ) {
            LayoutList.prototype.defaultEvents.keydown.call(this, event);
        }
    },
    data: [
        {items: [{className: 'item name', value: gettext('URL:')}, {className: 'item text', value: ''}]},
        {items: [{className: 'item name', value: gettext('File name:')}, {className: 'item text', value: ''}]},
        {items: [{className: 'item name', value: gettext('Size:')}, {className: 'item text', value: ''}]},
        {items: [{className: 'item name', value: gettext('Device:')}, {className: 'item text', value: ''}]},
        {items: [{className: 'item name', value: gettext('Status:')}, {className: 'item text', value: ''}]}
    ]
}));

page.panelDetails.add(page.panelDetails.button = new Button({
    value: gettext('Close'),
    className: 'bottom theme-footer',
    $node: page.panelDetails.$node.appendChild(document.createElement('div')),
    events: {
        click: function () {
            app.route(app.pages.main);
        },
        keydown: function ( event ) {
            if ( event.code === keys.up ) {
                page.panelDetails.list.focus();
                // restore taken focus class
                page.panelDetails.list.$focusItem.classList.add('focus');
                page.panelDetails.list.focusIndex(page.panelDetails.list.data.length - 1);
            } else if ( event.code === keys.down ) {
                page.panelDetails.list.focus();
                // restore taken focus class
                page.panelDetails.list.$focusItem.classList.add('focus');
                page.panelDetails.list.focusIndex(0);
            } else if ( event.code === keys.ok && page.panelDetails.button.events['click'] ) {
                page.panelDetails.button.emit('click', {event: event});
            }
        }
    }
}));

// panel set: download details
page.panelSet = new PanelSet({
    visible: false,
    $node: document.getElementById('panelSetInfo'),
    focusIndex: 0,
    panels: [page.panelDetails]
});
page.add(page.panelSet);


page.addListener('keydown', function ( event ) {
    switch ( event.code ) {
        case keys.back:
            app.route(app.pages.main);
            break;
    }
});

page.addListener('show', function ( data ) {
    page.panelSet.show();
    if ( data && data.data && data.data.data ) {
        page.initData = data.data.data.items[1].download.data;
        page.panelDetails.reset();
    }
});


// public
module.exports = page;
